import { Search, X } from 'lucide-react';
import { Input } from '../ui/input';

// Tek tıkla rol filtresi (sayılarla) + ad / e-posta / firma-kiracı araması
export const UserFilters = ({ counts, labels, role, onRole, q, onQ }) => {
  const chips = [['all', 'Tümü', counts.all || 0], ...Object.entries(labels).filter(([k]) => counts[k]).map(([k, v]) => [k, v.label, counts[k]])];
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center" data-testid="user-filters">
      <div className="relative lg:w-80">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => onQ(e.target.value)} placeholder="Ad, e-posta veya firma/kiracı ara" className="pl-9 pr-8" data-testid="user-search-input" />
        {q && <button type="button" onClick={() => onQ('')} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" data-testid="user-search-clear"><X className="h-4 w-4" /></button>}
      </div>
      <div className="flex flex-wrap gap-2">
        {chips.map(([k, label, n]) => (
          <button key={k} type="button" onClick={() => onRole(k)} data-testid={`user-role-filter-${k}`}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${role === k ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-400'}`}>
            {label} <span className={role === k ? 'text-slate-300' : 'text-slate-400'}>{n}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
